import { HStack, Text, VStack } from '@chakra-ui/react'
import { Patient } from '../../types'
import {
  displayIfPresent,
  validateDate,
  validateExists,
} from '../../utils/validation-helpers/Common'
import { validateIhi } from '../../utils/validation-helpers/IhiValidate'
import { validateMedicareNumber } from '../../utils/validation-helpers/MedicareValidate'
import { DVA_CARD_COLOUR } from '../PatientsPage/constants'
import { renderValidatedResult } from './jsxUtilities'

const IhiGenderToLabel = {
  M: 'Male',
  F: 'Female',
  I: 'Intersex or Indeterminate',
  N: 'Not State',
}

type IhiGender = keyof typeof IhiGenderToLabel

export const SelectedPatientIdentity = ({ patient }: { patient: Patient }) => (
  <VStack flexGrow="1" flexBasis="0" alignItems="stretch">
    <HStack>
      <Text fontWeight="bold">IHI:</Text>
      {renderValidatedResult(validateIhi(patient.ihi_number, patient.ihi_status))}
    </HStack>
    <HStack>
      <Text fontWeight="bold">Given Name:</Text>
      <Text>{patient.given_names}</Text>
    </HStack>
    <HStack>
      <Text fontWeight="bold">Family Name:</Text>
      <Text>{patient.family_name}</Text>
    </HStack>
    <HStack>
      <Text fontWeight="bold">Gender:</Text>
      <Text>{IhiGenderToLabel[patient.gender as IhiGender]}</Text>
    </HStack>
    <HStack>
      <Text fontWeight="bold">Date of Birth:</Text>
      {renderValidatedResult(
        validateDate(
          patient.date_of_birth,
          'Date of Birth',
          "Please update this patient's Date of birth."
        )
      )}
    </HStack>
    {patient.dva_file_no ? (
      <HStack spacing={4}>
        <HStack>
          <Text fontWeight="bold">DVA File Number:</Text>
          <Text>{patient.dva_file_no}</Text>
        </HStack>
        <HStack>
          <Text fontWeight="bold">DVA Card Colour:</Text>
          <Text>{DVA_CARD_COLOUR[patient.dva_card_colour]}</Text>
        </HStack>
      </HStack>
    ) : (
      patient.medicare_no && (
        <HStack spacing={4}>
          <HStack>
            <Text fontWeight="bold">Medicare Number:</Text>
            {renderValidatedResult(validateMedicareNumber(patient.medicare_no))}
          </HStack>
          <HStack>
            <Text fontWeight="bold">IRN:</Text>
            {renderValidatedResult(
              validateExists(
                patient.medicare_irn,
                'Medicare IRN',
                "Please update this patient's Medicare Individual Reference Number (IRN)."
              )
            )}
          </HStack>
        </HStack>
      )
    )}
    <HStack>
      <Text fontWeight="bold">Address:</Text>
      <VStack align="left" spacing="1px">
        <HStack>
          {renderValidatedResult(
            validateExists(
              patient.address_1,
              'Patient Address Line 1',
              'Please update patient address.'
            )
          )}
        </HStack>
        <HStack>
          {renderValidatedResult(
            displayIfPresent(
              patient.address_2,
              'Patient Address Line 2',
              'Please update patient address.'
            )
          )}
        </HStack>
        <HStack>
          {renderValidatedResult(
            validateExists(patient.suburb, 'Patient Suburb', 'Please update patient address.')
          )}
          {renderValidatedResult(
            validateExists(patient.postcode, 'Patient Postcode', 'Please update patient address.')
          )}
          {renderValidatedResult(
            validateExists(patient.state, 'Patient State', 'Please update patient address.')
          )}
        </HStack>
      </VStack>
    </HStack>
  </VStack>
)
